import { Print } from "@mui/icons-material";
import React, {  useRef, useState } from "react";
import { Link } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { assets } from "../../assets";
import {
  localDateFormat,
  localDateFormatName,
  localDateFormatNameBN,
  localTimeFormat,
} from "../../utils/dateFormat";
import { bnTimeFormat } from "../../utils/englishToBengaliNumber";
import OfficeAddress from "../OfficeAddress";
import NothiTransfer from "./NothiTransfer";

const HearingScheduleContent = ({ info }) => {
  const [isEdit, setIsEdit] = useState(false);
  const printLetter = useRef();

  const user = info?.hearing?.user;
  const hearing = info?.hearing;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center bg-slate p-2">
        <div className="fw-semibold">শুনানীর চিঠি</div>
        <ReactToPrint
          trigger={() => <Print className="fs-4 text-primary cursor-pointer" />}
          content={() => printLetter.current}
        />
      </div>
      {info.fileStatus === 10 && (
        <div className="card p-2 mt-2">
          <div>
            <label htmlFor="">সংশোধনের আদেশ</label>
            <p>{info?.hearing?.comment}</p>
          </div>
          <div className="d-flex justify-content-end">
            <div className="text-center">
              <div className="fw-semibold">আদেশক্রমে</div>
              <p className="m-0">{info?.hearing?.user?.name}</p>
              <p className="m-0">{info?.hearing?.user?.role?.bnName}</p>
              <div>তারিখ : {localDateFormat(info?.hearing?.updated_at)}</div>
              <div>সময় : {localTimeFormat(info?.hearing?.updated_at)}</div>
            </div>
          </div>
        </div>
      )}
      {info.fileStatus === 11 && (
        <div className="card p-2 mt-2">
          <span className="fw-semibold">হইতে, </span>{" "}
          {info?.hearing?.sendBy.name} ({info?.hearing?.sendBy?.role?.bnName})
        </div>
      )}

      <div className="py-2" ref={printLetter}>
        <div className="card p-3">
          <div ref={printLetter}>
            <div className="text-center">
              <img
                className="my-3"
                src={assets.logoBlack}
                style={{ width: "350px" }}
                alt=""
              />
              <OfficeAddress />
              <p className="m-0">
                <Link target="_blank" to={"//www.copyrightoffice.gov.bd"}>
                  www.copyrightoffice.gov.bd
                </Link>
              </p>
            </div>
            <div
              className={`d-flex justify-content-between py-3 mt-2 align-items-center`}
            >
              <div
                className={`d-flex gap-2 ${!isEdit && "align-items-center "}`}
              >
                <> {hearing?.record_no}</>
              </div>
              <div
                className={`d-flex gap-3 ${!isEdit && "align-items-center "}`}
              >
                <div className={`d-flex gap-3 ${isEdit && "mt-2"} fw-semibold`}>
                  তারিখঃ
                </div>
                <div>
                  <>
                    {localDateFormatNameBN(hearing?.record_date)}
                    <hr className="m-0" />
                    {localDateFormatName(hearing?.record_date)}
                  </>
                </div>
              </div>
            </div>
            <div>
              <p
                className={`fw-semibold mt-4 w-100 d-flex gap-2 ${
                  !isEdit && "align-items-center "
                }`}
              >
                <span className={`${isEdit && "mt-2"} `}>বিষয়ঃ </span>
                <> {hearing?.subject}</>
              </p>
            </div>
            {/* <p className="pb-4" style={{ textAlign: "justify" }}> */}
              <p
                className="m-0"
                dangerouslySetInnerHTML={{ __html: hearing?.detail }}
              ></p>
            {/* </p> */}
            <div className="d-flex justify-content-between my-2">
              <div>
                <div className={`d-flex gap-3 align-items-center`}>
                  <div className={`mt-2 fw-semibold`}>শুনানীর তারিখ ও সময়ঃ</div>
                </div>
                <div className={`d-flex gap-3 align-items-center`}>
                  <div>
                    <>
                      {localDateFormatName(hearing?.date) +
                        " ও " +
                        bnTimeFormat(hearing?.time)}
                    </>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <>
                  {user?.sign && (
                    <>
                      <img style={{ height: "40px" }} src={user?.sign} alt="" />
                    </>
                  )}
                  <p className="m-0">{user?.name}</p>
                  <p className="m-0">{user?.role?.bnName}</p>
                  <p className="m-0">{user?.email}</p>
                </>
              </div>
            </div>
            <div className="row">
              <div className="mt-3 col-md-6">
                {info.name && (
                  <>
                    {info?.sign && (
                      <>
                        <img
                          style={{ height: "40px" }}
                          src={info?.sign}
                          alt=""
                        />
                      </>
                    )}
                    <p className="m-0">{info?.name}</p>
                    <p className="m-0">{info?.email}</p>
                    <p className="m-0">{info?.address}</p>
                  </>
                )}
              </div>
            </div>
          </div>
          <div>
            <div className="d-flex gap-3 mt-3">
              {hearing?.isComplainant === 1 && (
                <span className="fw-semibold">বাদীঃ</span>
              )}
            </div>
            <div>
              {hearing?.isComplainant === 1 && (
                <div className="mt-3 row">
                  {hearing?.complainants.map((complainant, i) => (
                    <div key={i} className="col-md-12 mt-2">
                      <div className="mb-2">
                        <span>{complainant?.name}</span>
                      </div>
                      <div className="mb-2">
                        <span>{complainant?.mobile}</span>
                      </div>
                      <div className="mb-2">
                        <span>{complainant?.email}</span>
                      </div>
                      <div className="mb-2">
                        <span>{complainant?.address}</span>
                      </div>

                      <hr />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <NothiTransfer info={info} />
    </>
  );
};

export default HearingScheduleContent;
